module.exports = Em.Route.extend({
    model: function(params) {
        this.replaceWith('umbrella-invitation', params.token)
    }
})
